module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-form-item",
    class: {
      'is-error': _vm.validateState === 'error',
        'is-validating': _vm.validateState === 'validating',
        'is-required': _vm.isRequired || _vm.required
    }
  }, [(_vm.label || _vm.$slots.label) ? _c('label', {
    staticClass: "el-form-item__label",
    style: (_vm.labelStyle),
    attrs: {
      "for": _vm.prop
    }
  }, [_vm._t("label", [_vm._v(_vm._s(_vm.label + _vm.form.labelSuffix))])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content",
    style: (_vm.contentStyle)
  }, [_vm._t("default"), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [(_vm.validateState === 'error' && _vm.showMessage && _vm.form.showMessage) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.validateMessage))]) : _vm._e()])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cf7a9d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/element-ui/packages/form/src/form-item.vue
// module id = 1055
// module chunks = 0